var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.displayLoginWindow)?_c('div',[_c('modal',{attrs:{"closable":false,"size":_vm.modalSize,"backdrop-opacity":.8}},[_c('login-window',{on:{"navigate":_vm.navigate}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }